module.exports = __webpack_public_path__ + "static/media/FIND.9a231553.svg";